import config from '../../config';
import { HTTP } from '../../http';
import _ from 'lodash';

const pageSize = 25;
const enrollmentsUri = config.apiEndpoints.enrollmentsUri;

const enrollmentStatuses = [
  { id: 'PENDING',  name: 'Pendente'  },
  { id: 'APPROVED', name: 'Aprovado'  },
  { id: 'REJECTED', name: 'Rejeitado' },
];

const enrollmentKinds = [
  { id: 'ACTIVATION',  name: 'Ativação'  },
  { id: 'INACTIVATION', name: 'Inativação'  },
];

export default {
  findAll: (request) => {
    return new Promise((resolve, reject) => {
      const params = { page: request.page, pageSize };
      if (request.serialNumber)   params.serialNumber   = request.serialNumber;
      if (request.activationCode) params.activationCode = request.activationCode;
      if (request.modelId)        params.modelId        = request.modelId;
      if (request.status)         params.status         = request.status;
      if (request.sellerId)       params.sellerId       = request.sellerId;
      if (request.documentNumber) params.documentNumber = request.documentNumber;

      HTTP.get(enrollmentsUri.concat('search'), { params }).then(
        (response) => resolve(response),
        (error)    => reject(error)
      );
    });
  },

  findByActivationCode: (activationCode) => {
    return HTTP.get(enrollmentsUri.concat(`status/${activationCode}`));
  },

  approve: (activationCode, model) => {
    return HTTP.post(enrollmentsUri.concat(`${activationCode}/approve`), model);
  },

  getStatusList: () => _.clone(enrollmentStatuses),

  getStatusName: (status) => {
    const s = enrollmentStatuses.find((item) => item.id === status);
    return s ? s.name : status;
  },  
  getKindName: (kind) => {
    const k = enrollmentKinds.find((item) => item.id === kind);
    return k ? k.name : kind;
  },
};
